module.exports = __webpack_public_path__ + "img/oursolution6.c2f457ca.png";